import * as ccEndpoints from "../../lib/api/creditCardScanner";
import * as posActions from "../../lib/posActions";
import CreditCardScannerRegistration from "../CreditCardScannerRegisteration";
import React from "react";
import Spinner from "../Spinner";
import styles from "./DeviceSetup.module.css";
import TillAssignment from "../TillAssignment/TillAssignment";
import {useAppDispatch, useAppSelector} from "../../lib/hooks";
import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";

const isCreditCardScannerEnabled =
    import.meta.env.REACT_APP_CREDIT_CARD_SCANNER_ENABLED === "true"
        ? true
        : false;

type DeviceSetupState = {
    skipCCRegistrationCheck?: boolean;
};

export default function DeviceSetup() {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const locationState = location.state as DeviceSetupState;
    const stationMode = useAppSelector((state) => state.pos.station.mode);
    const isCCPaymentDisabled = useAppSelector(
        (state) => state.pos.station.isCCPaymentDisabled,
    );
    const [
        showCreditCardScannerRegistration,
        setShowCreditCardScannerRegistration,
    ] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (
            !isCreditCardScannerEnabled ||
            isCCPaymentDisabled ||
            locationState?.skipCCRegistrationCheck
        ) {
            setLoading(false);
            return;
        }

        ccEndpoints
            .testStationCardReaderConnection(stationMode)
            .then((isRegistered) => {
                setShowCreditCardScannerRegistration(!isRegistered);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const onSkipCCScannerRegistration = () => {
        setShowCreditCardScannerRegistration(false);
        dispatch(posActions.setStationCCPaymentDisabled(true));
    };

    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <Spinner />
            </div>
        );
    }

    if (showCreditCardScannerRegistration) {
        return (
            <CreditCardScannerRegistration
                onSuccess={() => {
                    setShowCreditCardScannerRegistration(false);
                }}
                onSkipRegistration={onSkipCCScannerRegistration}
            />
        );
    } else {
        return <TillAssignment />;
    }
}
